import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { FC } from 'react'
import { AvailabilityDisplay } from '../../helpers/get-availability-status'

interface AvailabilityIconProps {
    display: AvailabilityDisplay
}

const iconStyle = { fontSize: '14px' }

const colors = {
    success: 'green',
    waiting: 'orange',
    problem: 'red',
}

const AvailabilityIcon: FC<AvailabilityIconProps> = ({ display }) => {
    if (display.inStock) {
        return <CheckCircleOutlined style={{ ...iconStyle, color: colors.success }} />
    }

    const tooltipText = display.waiting || display.problem
    const lines = tooltipText?.split('\n').filter(Boolean) ?? []
    const tooltipTitle =
        lines.length > 1 ? (
            <div>
                {lines.map(line => (
                    <div key={line}>{line}</div>
                ))}
            </div>
        ) : (
            tooltipText
        )

    if (display.waiting) {
        return (
            <Tooltip title={tooltipTitle}>
                <ClockCircleOutlined style={{ ...iconStyle, color: colors.waiting }} />
            </Tooltip>
        )
    }

    return (
        <Tooltip title={tooltipTitle}>
            <CloseCircleOutlined style={{ ...iconStyle, color: colors.problem }} />
        </Tooltip>
    )
}

export default AvailabilityIcon
